/* ============================================================
   Carnet Moralès — kit article (seo-journal-kit)
   1. Temps de lecture dans la byline
   2. Sommaire ancré auto-généré depuis les H2 du body
   3. Hydratation des cartes produit (prix LIVE via /products/<handle>.js)
   Identique au kit MRB (logique transverse, sans rien de propre à une marque).
   Chargé (defer) par sections/main-article.liquid uniquement.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var container = document.querySelector('.article-container');
    if (!container) return;
    readingTime(container);
    buildToc(container);
    hydrateProductCards(container);
    faqAccordions(container);
    progressBar();
  }

  /* --- Template journal : FAQ h3+contenu -> accordéons <details> --- */
  function faqAccordions(container) {
    if (!document.querySelector('[data-cjy-body]')) return; // journal uniquement
    var h2s = container.querySelectorAll('h2');
    var faqH2 = null;
    h2s.forEach(function (h) { if (/^faq/i.test(h.textContent.trim())) faqH2 = h; });
    if (!faqH2) return;
    var node = faqH2.nextElementSibling;
    while (node && node.tagName === 'H3') {
      var d = document.createElement('details');
      d.className = 'seo-faq';
      var s = document.createElement('summary');
      s.textContent = node.textContent;
      d.appendChild(s);
      var content = node.nextElementSibling;
      var next;
      while (content && !/^H[23]$/.test(content.tagName) && !content.classList.contains('cjy-auteur')) {
        next = content.nextElementSibling;
        d.appendChild(content);
        content = next;
      }
      node.replaceWith(d);
      node = d.nextElementSibling;
    }
    var first = container.querySelector('details.seo-faq');
    if (first) first.open = true;
  }

  /* --- Template journal : barre de progression de lecture --- */
  function progressBar() {
    var bar = document.querySelector('[data-cjy-progress]');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var h = document.documentElement;
      bar.style.width = (h.scrollTop / (h.scrollHeight - h.clientHeight) * 100) + '%';
    }, { passive: true });
  }

  /* --- 1. Temps de lecture --- */
  function readingTime(container) {
    var slot = document.querySelector('.seo-reading-time');
    if (!slot) return;
    var words = (container.innerText || '').trim().split(/\s+/).length;
    var minutes = Math.max(1, Math.round(words / 220));
    slot.textContent = minutes + ' min de lecture';
    slot.hidden = false;
  }

  /* --- 2. Sommaire ancré : dans le rail (template journal) sinon inline --- */
  function buildToc(container) {
    var h2s = container.querySelectorAll('h2');
    var rail = document.querySelector('[data-cjy-toc]');
    if (h2s.length < (rail ? 3 : 4)) return;
    h2s.forEach(function (h2, i) {
      if (!h2.id) {
        h2.id = 'section-' + (i + 1) + '-' + h2.textContent.toLowerCase()
          .normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 60);
      }
    });
    if (rail) {
      var links = [];
      h2s.forEach(function (h2) {
        var a = document.createElement('a');
        a.href = '#' + h2.id;
        a.textContent = h2.textContent;
        rail.appendChild(a);
        links.push({ a: a, h2: h2 });
      });
      rail.hidden = false;
      window.addEventListener('scroll', function () {
        var cur = 0;
        links.forEach(function (l, i) {
          if (l.h2.getBoundingClientRect().top < 130) cur = i;
        });
        links.forEach(function (l, i) { l.a.classList.toggle('on', i === cur); });
      }, { passive: true });
      return;
    }
    var toc = document.createElement('nav');
    toc.className = 'seo-toc';
    var title = document.createElement('div');
    title.className = 'seo-toc__title';
    title.textContent = 'Sommaire';
    toc.appendChild(title);
    var ol = document.createElement('ol');
    h2s.forEach(function (h2) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h2.id;
      a.textContent = h2.textContent;
      li.appendChild(a);
      ol.appendChild(li);
    });
    toc.appendChild(ol);
    container.insertBefore(toc, container.firstChild.nextSibling || container.firstChild);
  }

  /* --- 3. Cartes produit : prix et image en direct, jamais codés en dur --- */
  function hydrateProductCards(container) {
    var cards = container.querySelectorAll('.seo-product-card[data-handle]');
    cards.forEach(function (card) {
      var handle = card.getAttribute('data-handle');
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) { renderCard(card, p); loadReviews(card, handle); })
        .catch(function () { card.style.display = 'none'; });
    });
  }

  function renderCard(card, p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var label = card.getAttribute('data-label') || p.title;
    var html = '';
    if (img) {
      html += '<a href="' + p.url + '"><img class="seo-product-card__img" loading="lazy" src="' +
        img + '" alt="' + escapeHtml(label) + '"></a>';
    }
    html += '<div class="seo-product-card__body">' +
      '<p class="seo-product-card__title"><a href="' + p.url + '">' + escapeHtml(label) + '</a></p>' +
      '<div data-reviews-slot></div>' +
      '<p class="seo-product-card__promise">Nos épices sont 100% brutes et récoltées récemment, en fioles rechargeables et consignées.</p>' +
      '<a href="' + p.url + '" class="btn seo-product-card__cta">Découvrir</a>';
    html += '</div>';
    card.innerHTML = html;
  }

  /* --- Avis réels : /products/<handle>.js n'expose pas les metafields,
     on fetch le fragment layout:none dédié (templates/product.reviews-badge.liquid) --- */
  function loadReviews(card, handle) {
    var slot = card.querySelector('[data-reviews-slot]');
    if (!slot) return;
    fetch('/products/' + handle + '?view=reviews-badge')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        /* Le fragment renvoie la page complete du template : on ne garde que le badge,
           sinon un <link rel=stylesheet> atterrit dans la colonne flex de la carte et
           y ajoute un gap fantome au-dessus du texte. */
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        Array.prototype.forEach.call(tmp.querySelectorAll('link, style, script, noscript'),
          function (n) { n.parentNode.removeChild(n); });
        var badge = tmp.querySelector('.product-card__reviews') || tmp.firstElementChild;
        if (badge && badge.textContent.trim()) { slot.parentNode.replaceChild(badge, slot); }
        else { slot.remove(); }
      })
      .catch(function () { slot.remove(); });
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
